<template>

	<div>
		<div class="card shadow-sm mb-4">
			<div class="card-header">
				<h4 class="my-0 font-weight-normal">Existing API Keys</h4>
			</div>
			<div class="card-body">

				Here is a full list of API keys. The next release will have a full API key search and browser:

				<ul class="list-unstyled mt-3 mb-4">
					<li v-for="( apiKey, index ) in apiKeyList" :key="index">
						<router-link :to="'/nodes/'+ nodeId +'/projects/'+ projectId +'/apikeys/'+ apiKey.$id.split(':')[1] ">{{apiKey.title}} ({{apiKey.$id}})</router-link>
					</li>
				</ul>

				<button class="btn btn-primary" @click.prevent="loadApiKeys( true )"><i class="fas fa-sync-alt"></i> Refresh</button>

			</div>
		</div>

		<div class="card shadow-sm mb-4">
			<div class="card-header">
				<h4 class="my-0 font-weight-normal">New API Key</h4>
			</div>
			<div class="card-body">
				<form autocomplete="off">
					<div class="form-group">
						<label for="newApiKey_id">Title</label>
						<input v-model="newApiKey.title" type="text" class="form-control" id="newApiKey_title" aria-describedby="newApiKey_titleHelp" placeholder="Enter title">
						<small id="newApiKey_titleHelp" class="form-text text-muted">Title (name) for this API Key (e.g. "Access for Joe's Online Store")</small>
					</div>
					<div class="form-group">
						<label for="newApiKey_desc">Description</label>
						<textarea v-model="newApiKey.description" type="text" class="form-control" id="newApiKey_desc" aria-describedby="newApiKey_descHelp" placeholder="Enter description" rows="2"></textarea>
						<small id="newApiKey_descHelp" class="form-text text-muted">Descriptive details (e.g. "This is a testing API key")</small>
					</div>
					<div class="form-check mb-3">
						<input v-model="newApiKey.disabled" type="checkbox" class="form-check-input" id="newApiKey_disabled">
						<label class="form-check-label" for="newApiKey_disabled">Disabled <small class="text-muted">(this API key will not be active)</small></label>
					</div>
					<div class="form-group">
						<label for="newApiKey_starts">Active Starting Date</label>
						<input v-model="newActiveStarts" type="datetime-local" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}" class="form-control" id="newApiKey_starts" aria-describedby="newApiKey_starts" placeholder="Enter starting date">
						<small id="newApiKey_startsHelp" class="form-text text-muted">The date and time at which this API key will start to be active.</small>
					</div>
					<div class="form-group">
						<label for="newApiKey_expires">Expiry Date</label>
						<input v-model="newActiveExpires" type="datetime-local" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}" class="form-control" id="newApiKey_expires" aria-describedby="newApiKey_expires" placeholder="Enter expiry date">
						<small id="newApiKey_expiresHelp" class="form-text text-muted">The date and time at which this API key expires, and becomes inactive.</small>
					</div>
					<div class="form-group">
						<label for="newApiKey_projPerm">Project-Wide Permission Role</label>
						<div class="form-check">
							<input v-model="newProjectRole" type="radio" name="projRole" value="" class="form-check-input" id="newApiKey_projPerm_none">
							<label class="form-check-label text-muted" for="newApiKey_projPerm_none"><em>None</em> <small class="text-muted">(no project-wide access, usually used with collection-sepcific permissions below)</small></label>
						</div>
						<div class="form-check">
							<input v-model="newProjectRole" type="radio" name="projRole" value="read" class="form-check-input" id="newApiKey_projPerm_read">
							<label class="form-check-label" for="newApiKey_projPerm_read">Read <small class="text-muted">(complete read access for all collections, including readonly for project settings)</small></label>
						</div>
						<div class="form-check">
							<input v-model="newProjectRole" type="radio" name="projRole" value="write" class="form-check-input" id="newApiKey_projPerm_write">
							<label class="form-check-label" for="newApiKey_projPerm_write">Write <small class="text-muted">(complete read/write for all collections, including readonly for project settings)</small></label>
						</div>
						<div class="form-check">
							<input v-model="newProjectRole" type="radio" name="projRole" value="admin" class="form-check-input" id="newApiKey_projPerm_admin">
							<label class="form-check-label" for="newApiKey_projPerm_admin"><span style="color: red;">Admin</span> <small class="text-muted">(complete access to collections and editing of project settings, other than ownership)</small></label>
						</div>
					</div>
					
					<div class="form-group">
						<label>Collection-Specific Permissions</label>
						<table class="table table-bordered table-hover table-responsive">
							<thead>
								<tr>
									<th scope="col" style="width: 100%;">Collection Name <em class="text-muted">(ID)</em></th>
									<th scope="col" class="text-center" style="min-width: 80px;">Read</th>
									<th scope="col" class="text-center" style="min-width: 80px;">List</th>
									<th scope="col" class="text-center" style="min-width: 80px;">Create</th>
									<th scope="col" class="text-center" style="min-width: 80px;">Update</th>
									<th scope="col" class="text-center table-danger" style="min-width: 80px;">Delete</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="collection in collectionList" :key="collection.$id">
									<th scope="row" class="font-weight-normal">{{collection.title}} <em class="text-muted">({{collection.$id.split(':')[1]}})</em></th>
									<td class="text-center"><input v-model="newCollectionPermissions[collection.$id+'.r']" type="checkbox"></td>
									<td class="text-center"><input v-model="newCollectionPermissions[collection.$id+'.l']" type="checkbox"></td>
									<td class="text-center"><input v-model="newCollectionPermissions[collection.$id+'.c']" type="checkbox"></td>
									<td class="text-center"><input v-model="newCollectionPermissions[collection.$id+'.u']" type="checkbox"></td>
									<td class="text-center table-danger"><input v-model="newCollectionPermissions[collection.$id+'.d']" type="checkbox"></td>
								</tr>
							</tbody>
						</table>
					</div>
					
					<button class="btn btn-success mt-4" @click.prevent="createApiKeyFromData"><i class="fas fa-star"></i> Create API Key</button>
				</form>
			</div>
		</div>

		<div class="card shadow-sm">
			<div class="card-header">
				<h4 class="my-0 font-weight-normal">Create New API Key</h4>
			</div>
			<div class="card-body">
				<div id="editor"></div>
				<button class="btn btn-success mt-4" @click.prevent="createApiKeyFromEditor"><i class="fas fa-star"></i> Create API Key</button>
			</div>
		</div>

	</div>

</template>

<script>

import 'ace-builds';
import 'ace-builds/webpack-resolver';

import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { toJsonDate } from '../util';
import _ from 'lodash';

export default {
	name: "project-api-keys",
	props: [ 'nodeId', 'projectId' ],
	data() {
		return {
			newApiKey:
			{
				$schema : "sys:apikey.",
				title : "",
				description : "",
				permissions : {
					project : {

					},
					collections : {

					}
				}
			},
			newProjectRole: "",
			newActiveStarts: "",
			newActiveExpires: "",
			newCollectionPermissions: { },
			apiKeyList : []
		};
	},
	watch:
	{
		newCollectionPermissions:
		{
			deep: true,
			handler: function( newValue, oldValue )
			{
				let dataPermissions = { };
				for( let p in newValue )
				{
					let permission = newValue[p];

					let [ cid, type ] = p.split( '.' );
					let [ project, cname ] = cid.split( ':' );
					if( !dataPermissions[cname] )
						dataPermissions[cname] = { };
					
					if( permission === true )
						dataPermissions[cname][type] = permission;
				}
				if( !this.newApiKey.permissions )
					this.newApiKey.permissions = { };
				this.$set( this.newApiKey.permissions, 'collections', dataPermissions );
			}
		},
		newProjectRole: function( newValue, oldValue )
		{
			if( !this.newApiKey.permissions )
				this.newApiKey.permissions = { };
			if( newValue === 'read' || newValue === 'write' || newValue === 'admin' )
				this.newApiKey.permissions.project = { [newValue] : true };
			else
				this.newApiKey.permissions.project = { };
		},
		newActiveStarts: function( newValue, oldValue )
		{
			try {
				this.$set( this.newApiKey, 'starts', toJsonDate( this.newActiveStarts ) );
			} catch( err ) { this.$delete( this.newApiKey, 'starts' ); }
		},
		newActiveExpires: function( newValue, oldValue )
		{
			try {
				this.$set( this.newApiKey, 'expires', toJsonDate( this.newActiveExpires ) );
			} catch( err ) { this.$delete( this.newApiKey, 'expires' ); }
		},
		newApiKey:
		{
			deep: true,
			handler: function( newValue, oldValue )
			{
				try {
					let projPerm = this.newApiKey.permissions.project;
					for( let role in projPerm )
						if( projPerm[role] !== true )
							delete projPerm[role];
				} catch( err ) { }
				this.editor.setValue( JSON.stringify( this.newApiKey, null, 2 ), -1 );
			}
		}
	},
	components: { },
	computed:
	{
		currentSessionAccount: function( )
		{
			try {
				let sessionGuid = this.activeSession( this.nodeId );
				let [ sNode, sKey ] = sessionGuid.split( "/" );
				let session = this.session( sessionGuid );
				let account = this.account( sNode, session.account );
				if( account )
					return account;
			} catch( err ) { }
			return { };	// No session.
		},
		...mapGetters( "accounts", {
			account: "account",
		}),
		...mapGetters( "authentication", {
			activeSession: "activeSession",
			session: "session"
		}),
		...mapGetters( "apiKeys", {
			apiKeys: "apiKeys", // map STATE apiKeys/apiKeys to "apiKeys" AS A FUNCTION, which requires the nodeId and projectId as inputs!
		}),
		...mapGetters( "collections", {
			collections: "collections",
		}),
		collectionList( ) {
			return this.collections( this.nodeId, this.projectId );
		}
	},
	methods: {
		...mapActions({
			listApiKeys: "apiKeys/list",
			createApiKey: "apiKeys/create",
			listCollections: "collections/list"
		}),
		async checkMySession( )
		{
			try {
				let sessionGuid = this.$store.getters['authentication/activeSession']( this.nodeId );
				return await this.$store.dispatch( 'authentication/checkSession', { nodeId : this.nodeId, sessionKey : sessionGuid } );
			} catch( err ) { console.error( err ); return null; }
		},
		getApiKeys( )
		{
			return this.apiKeys( this.nodeId, this.projectId );
		},
		async loadApiKeys( nocache )
		{
			try {
				await this.listApiKeys( { nodeId : this.nodeId, projectId : this.projectId, nocache : nocache } );
				this.apiKeyList = this.apiKeys( this.nodeId, this.projectId );
			} catch( err ) {
				if( err.response && ( err.response.status === 401 ) )
				{
					console.warn( "Session expired, invalid or missing.." );
					this.checkMySession( );
				}
				else
					throw err;
			}
		},
		async createApiKeyFromData( )
		{
			// TODO: Set loading overlay
			await this.createNewApiKey( this.newApiKey );
		},
		async createApiKeyFromEditor( )
		{
			// TODO: Set loading overlay
			let apiKey;

			try {
				apiKey = JSON.parse( this.editor.getValue( ) );
			} catch( err ) {
				alert( "API Key format issue:\n"+ err.message );
				console.error( err );
				return;
			}

			await this.createNewApiKey( apiKey );
		},
		async createNewApiKey( apiKey )
		{
			// UI Validation
			if( !apiKey.title ) return alert( "Must define a apiKey Title ('title' field)" );
			
			try {
				let result = await this.createApiKey( { nodeId : this.nodeId, projectId : this.projectId, newApiKey : apiKey } );
				if( !result.$id )
					throw new Error( "Result from apiKey creation came back without an ID!" );
				this.apiKeyList = this.apiKeys( this.nodeId, this.projectId );
				let [ projectId, theKey ] = result.$id.split( ":" );
				this.$router.push( { name : 'apikey', params : { nodeId : this.nodeId, projectId, theKey } } );
				// TODO: close loading overlay
			} catch( err ) {

				// TODO: Switch loading overlay to ERROR overlay.

				console.warn( "API Key creation failed:", err );
				alert( "API Key creation failed!\n"+ err.message );
				// TODO: Set this action, as the result of dismissing the ERROR OVERLAY
			}
		}
	},
	async created( )
	{
		this.apiKeyList = this.getApiKeys( );	// Get apiKeys from cache.
		await this.loadApiKeys( true );	// Reload apiKeys in the background to make sure we have the latest.
	},
	async mounted( )
	{
		try {
			this.editor = ace.edit( "editor", {
				mode: "ace/mode/json",
				theme: "ace/theme/tomorrow",	//"ace/theme/dracula",
				maxLines: 20,
				minLines: 5,
				fontSize: 14,
				showPrintMargin : false
			});
			this.editor.setValue( JSON.stringify( this.newApiKey, null, 2 ), -1 );
			await this.listCollections( { nodeId : this.nodeId, projectId : this.projectId } );
		} catch( err ) { throw err; }
	}
};
</script>
<style scoped>
div#editor
{
	border: 1px solid #666;
}
h2 {
	font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/ApiKeys.vue